export const CRAWL_SUCCESS = "SYNCHRONIZED_COMPLAINT.CRAWL_SUCCESS";
export const CRAWL_FAIL = "SYNCHRONIZED_COMPLAINT.CRAWL_FAIL";
export const DONT_LOGIN_SITE = "SYNCHRONIZED_COMPLAINT.DONT_LOGIN_SITE";
export const CLOSE_TAB = "SYNCHRONIZED_COMPLAINT.CLOSE_TAB";
